export const checkLiveAvailability = (
  space: { venue: { liveAvailability: boolean } },
  liveAvailabilityFilter: boolean,
) => {
  if (!liveAvailabilityFilter) {
    return true;
  }

  return space.venue.liveAvailability;
};
